import { api } from "../api";

export const getBaseData = async () => {
  let url = "/";
  return await api.get(url);
};